import Switch from '@components/switch/Switch';
import { handleChangeFormName, handleOpenModelForm } from '@lib/store/slices/ComponentsSlice';
import { setSelectedBenefit } from '@lib/store/slices/EqualizerSlice';
import formatLongPrice from '@lib/tools/_format-long-price';
import getPaymentText from '@lib/tools/_get-payment-text';
import { SafeHtmlRenderer } from '@lib/tools/helpers/SafeHtmlRenderer';
import { useDispatch } from 'react-redux';
import styles from './CardProgram.module.scss';
const splitListToValue = input => {
  const result = input?.split(/—|&mdash;/);
  if (result?.length === 1) {
    return `<p>${result[0]}</p>`;
  }
  return `<p>${result[0]}</p><p>${result[1]}</p>`;
};
const CardProgram = ({
  benefit,
  flat,
  selectedBenefit,
  payment,
  period,
  isMinFirstPayment,
  isMobile,
  setPayment,
  setPeriod,
  fetchData
}) => {
  const dispatch = useDispatch();
  const list = benefit?.description?.split(/<br>|\n/) || [''];
  const isInactive = payment < benefit?.mortgage?.minPrice;
  const bookingUrl = `/market/booking?flatId=${flat?.id}&firstPayment=${Math.floor(payment)}&loanTerm=${Math.floor(period)}&benefitGuid=${selectedBenefit?.guid}&flatGuid=${flat?.guid}`;
  const onChangePayment = e => {
    //останавливаем всплытие, чтобы не произошел клик на весь бенефит и не отправился неверный запрос
    e.stopPropagation();
    // делаем запрос к пику с нужными данными fetchData
    setPayment(benefit?.mortgage?.minPrice);
    dispatch(setSelectedBenefit(benefit));
    if (benefit?.mortgage?.minPeriod > period) {
      setPeriod(benefit?.mortgage?.minPeriod);
      fetchData(benefit?.mortgage?.minPrice, benefit?.mortgage?.minPeriod, benefit?.id);
    } else {
      fetchData(benefit?.mortgage?.minPrice, period, benefit?.id);
    }
  };
  const onClickSelectionCard = () => {
    // делаем запрос к пику с нужными данными fetchData
    if (benefit?.mortgage?.minPeriod > period) {
      fetchData(payment, benefit?.mortgage?.minPeriod, benefit?.id);
    }
    if (benefit?.mortgage?.maxPrice < payment) {
      setPayment(benefit?.mortgage?.maxPrice);
      fetchData(benefit?.mortgage?.maxPrice, period, benefit?.id);
    }
    if (benefit?.mortgage?.minPeriod <= period && benefit?.mortgage?.maxPrice >= payment) {
      fetchData(payment, period, benefit?.id);
    }
    if (isMinFirstPayment) setPayment(benefit?.mortgage?.minPrice);
    dispatch(setSelectedBenefit(benefit));
  };
  const renderData = () => {
    return <>
        <div className={styles.benefit__description}>
          <div className={styles.benefit__title}>
            <div>{benefit?.name}</div>
            <SafeHtmlRenderer content={list?.length === 1 ? benefit?.description : list[0]} tag='p' />
          </div>

          {list.length > 1 && <ul className={styles.benefit__list}>
              {list?.map((listItem, i) => {
            if (i === 0) return null;
            if (listItem.length > 0) {
              return <SafeHtmlRenderer key={listItem.id} tag='li' content={splitListToValue(listItem) || ''} />;
            }
            return null;
          })}
            </ul>}
        </div>

        <div className={styles.benefit__right}>
          <div className={`${styles.benefit__insufficient} ${isInactive ? styles.benefit__insufficient_visible : ''}`}>
            <p className={styles.benefit__insufficientText}>Недостаточный первый взнос</p>

            <button className={styles.benefit__insufficientBtn} onClick={e_0 => onChangePayment(e_0)}>
              Установить подходящий
            </button>
          </div>

          <div className={styles.benefit__priceBlock}>
            <div className={styles.benefit__priceBlockTop}>
              <div className={styles.benefit__price}>
                <div>{formatLongPrice(benefit?.benefitPrice)} ₽</div>
              </div>
              <div className={` ${styles.benefit__checkbox} ${selectedBenefit.id === benefit.id ? styles.benefit__checkbox_selected : undefined}`} />
            </div>

            {benefit?.mortgage?.monthFeeWithoutInterest && getPaymentText(benefit?.type) ? <>
                <div>
                  <div className={styles.caption__bold}>{getPaymentText(benefit?.type)[0]}</div>
                  <h3 className={styles.price}>{formatLongPrice(benefit?.mortgage?.monthFeeWithoutInterest)} ₽</h3>
                </div>
                <div>
                  <div className={styles.caption__bold}>{getPaymentText(benefit?.type)[1]}</div>
                  <h3 className={styles.price}>{formatLongPrice(benefit?.mortgage?.minMonthFee)} ₽</h3>
                </div>
              </> : <div>
                <div className={styles.caption__bold}>Платеж в месяц</div>
                <h3 className={styles.price}>{formatLongPrice(benefit?.mortgage?.minMonthFee)} ₽</h3>
              </div>}

            {flat?.bookingStatus === 'active' && flat?.has_advertising_price !== 1 && <a href={bookingUrl} target='_blank' rel='noreferrer' className={styles.modal__btn}>
                Забронировать
              </a>}
            {isMobile && selectedBenefit.id === benefit.id && flat?.bookingStatus === 'reserve' && <Switch handleSwitch={() => {
            dispatch(handleOpenModelForm(true));
            dispatch(handleChangeFormName('flatForm'));
          }} switchText='Оставить заявку' testId='flatFormOpen' black={true} someStyles={styles.callBtn} />}
            {isMobile && selectedBenefit.id !== benefit.id && <button className={styles.modal__btn}>Выбрать</button>}
          </div>
        </div>
      </>;
  };
  return <div className={`${styles.benefit}  ${isInactive ? styles.benefit_inactive : ''}  ${selectedBenefit?.id === benefit?.id ? styles.benefit_selected : ''}`} onClick={() => onClickSelectionCard()}>
      {renderData()}
    </div>;
};
export default CardProgram;